module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a8162033b0ccec7c13d61aa2f2aa0175.png";